import { render, staticRenderFns } from "./LayoutCarousel.vue?vue&type=template&id=65ea91e0&scoped=true"
import script from "./LayoutCarousel.vue?vue&type=script&lang=js"
export * from "./LayoutCarousel.vue?vue&type=script&lang=js"
import style0 from "./LayoutCarousel.vue?vue&type=style&index=0&id=65ea91e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ea91e0",
  null
  
)

export default component.exports